"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeLeadingSlash = exports.getRedirectUrl = void 0;
var tslib_1 = require("tslib");
var locale_1 = tslib_1.__importDefault(require("./locale"));
// eslint-disable-next-line prefer-destructuring, no-underscore-dangle
var _MARKETPLACE = process.env._MARKETPLACE;
var IS_BROWSER = typeof window !== 'undefined';
exports.getRedirectUrl = function (isoLocale, path, app) {
    if (app === void 0) { app = 'www'; }
    var appLocation = app;
    var domain = _MARKETPLACE;
    if (IS_BROWSER) {
        var urlSegments = window.location.hostname.split('.');
        var isAlt = urlSegments[0].includes('-alt');
        domain = urlSegments[1];
        appLocation = isAlt ? appLocation + "-alt" : appLocation;
    }
    return "https://" + appLocation + "." + domain + ".com/" + locale_1.default.getSEOLocale(isoLocale) + "/" + (exports.removeLeadingSlash(path) || '');
};
exports.removeLeadingSlash = function (url) {
    if (url === void 0) { url = ''; }
    return (url[0] === '/' ? url.slice(1) : url);
};
//# sourceMappingURL=url.js.map